import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import { Observable } from "rxjs";
import { ResponseListingPerformanceEval } from "../dto/performance-evaluation.dto";

@Injectable()
export class PerformanceMonitoringApi {

  private service: string = '';
  private model: string = 'sf6s/performanceMonitoring';
  private timeout: number = 60000;

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: ResponseListingPerformanceEval, page: string | number, limit: string | number): Observable<ResponseListingPerformanceEval> {
    const method: string = 'POST';
    const func: string = 'listing';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseListingPerformanceEval>(method, url, params, urlParams, body, contentType, (10 * 60) * 1000);
  }

  public history(requestNo: string, periodCode: string, empId: string, referenceDate: Date, formNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof referenceDate !== 'undefined' && referenceDate !== null) urlParams.referenceDate = referenceDate;
    if (typeof formNo !== 'undefined' && formNo !== null) urlParams.formNo = formNo;
    
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, null, 100000);
  }

  public empData(periodCode: string, empId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'empData';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  add(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "add";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';


    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, contentType, this.timeout);
  }

  public revisionHistory(formNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'revisionHistory';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof formNo !== 'undefined' && formNo !== null) urlParams.formNo = formNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public revisionDetail(requestNo: string, periodCode: string, empId: string, referenceDate: Date, formNo: string, reviewerEmpid: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof referenceDate !== 'undefined' && referenceDate !== null) urlParams.referenceDate = referenceDate;
    if (typeof formNo !== 'undefined' && formNo !== null) urlParams.formNo = formNo;
    if (typeof reviewerEmpid !== 'undefined' && reviewerEmpid !== null) urlParams.reviewerEmpid = reviewerEmpid;
    
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, null, 60000);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/performance-monitoring.api.ts